export const BOOKING_TYPE = {
  BOOKING: "Booking",
  BLOCKING: "Blocking",
};

export const TOAST_MESSAGES = {
  dates_conflicting_message:
    "This date range is conflicting with another booking. Please, select different dates",
  successfully_updated: "Booking successfully updated",
  successfully_created: "Booking successfully created",
  error_while_creating: "Error while create new booking",
  error_updating: "Error while updating booking",
};
